import { Typography } from "@mui/material";

const AdminLandingPage = () => {
  return (
    <Typography sx={{ marginTop: "200px" }}>ADMIN LANDING HERE...</Typography>
  );
};

export default AdminLandingPage;
